import { isWeekend } from "../../../../../utils";
import { ReportStrategy } from "./reportBuilder";
import { ISalesStatsByDayResponse } from "../../../../../api/billing/index.types";

const HEADER_ROW = [
  "Date",
  "Total Net",
  "US Net",
  "Non-us Net",

  "TCP25K QT",
  "TCP25K NT",
  "TCP25K rebill",
  "TCP25K NT resets",
  "TCP25K paid resets",
  "TCP25K free resets",

  "TCP50K QT",
  "TCP50K NT",
  "TCP50K rebill",
  "TCP50K NT resets",
  "TCP50K paid resets",
  "TCP50K free resets",

  "TCP100K QT",
  "TCP100K NT",
  "TCP100K rebill",
  "TCP100K NT resets",
  "TCP100K paid resets",
  "TCP100K free resets",

  "GAU MINI 50K QT",
  "GAU MINI 50K NT",
  "GAU MINI 50K rebill",
  "GAU MINI 50K NT resets",
  "GAU MINI 50K paid resets",
  "GAU MINI 50K free resets",

  "GAU MINI 100 QT",
  "GAU MINI 100 NT",
  "GAU MINI 100 rebill",
  "GAU MINI 100 NT resets",
  "GAU MINI 100 paid resets",
  "GAU MINI 100 free resets",

  "GAU MINI 150K QT",
  "GAU MINI 150K NT",
  "GAU MINI 150K rebill",
  "GAU MINI 150K NT resets",
  "GAU MINI 150K paid resets",
  "GAU MINI 150K free resets",

  "GAU MINI 200K QT",
  "GAU MINI 200K NT",
  "GAU MINI 200K rebill",
  "GAU MINI 200K NT resets",
  "GAU MINI 200K paid resets",
  "GAU MINI 200K free resets",

  "RESETS QT",
  "RESETS NT",
  "FREE RESETS",
];
export class DetailedSalesReportStrategy implements ReportStrategy {
  private readonly outputRows = [HEADER_ROW];
  private readonly isIgnoreWeekends: boolean = false;
  private readonly sourceData: ISalesStatsByDayResponse["data"]["report"] = [];

  constructor(sourceData: ISalesStatsByDayResponse["data"]["report"], isIgnoreWeekends: boolean) {
    this.sourceData = sourceData;
    this.isIgnoreWeekends = isIgnoreWeekends;
  }

  populateRows(): void {
    this.sourceData.forEach((row) => {
      const {
        date,

        gau50_net_not_us,
        gau50_rebill_net_not_us,
        gau100_net_not_us,
        gau100_rebill_net_not_us,
        gau150_net_not_us,
        gau150_rebill_net_not_us,
        gau200_net_not_us,
        gau200_rebill_net_not_us,
        tcp25_net_not_us,
        tcp25_rebill_net_not_us,
        tcp50_net_not_us,
        tcp50_rebill_net_not_us,
        tcp100_net_not_us,
        tcp100_rebill_net_not_us,

        gau50_reset_net_us,
        gau50_reset_net_not_us,
        gau100_reset_net_us,
        gau100_reset_net_not_us,
        gau150_reset_net_us,
        gau150_reset_net_not_us,
        gau200_reset_net_us,
        gau200_reset_net_not_us,
        tcp25_reset_net_us,
        tcp25_reset_net_not_us,
        tcp50_reset_net_us,
        tcp50_reset_net_not_us,
        tcp100_reset_net_us,
        tcp100_reset_net_not_us,

        gau50_net_us,
        gau50_rebill_net_us,
        gau100_net_us,
        gau100_rebill_net_us,
        gau150_net_us,
        gau150_rebill_net_us,
        gau200_net_us,
        gau200_rebill_net_us,
        tcp25_net_us,
        tcp25_rebill_net_us,
        tcp50_net_us,
        tcp50_rebill_net_us,
        tcp100_net_us,
        tcp100_rebill_net_us,

        resets_net_us,
        resets_net_not_us,

        gau50_qt,
        gau100_qt,
        gau150_qt,
        gau200_qt,
        tcp25_qt,
        tcp50_qt,
        tcp100_qt,

        gau50_paid_reset_qt,
        gau50_free_reset_qt,
        gau100_paid_reset_qt,
        gau100_free_reset_qt,
        gau150_paid_reset_qt,
        gau150_free_reset_qt,
        gau200_paid_reset_qt,
        gau200_free_reset_qt,
        tcp25_paid_reset_qt,
        tcp25_free_reset_qt,
        tcp50_paid_reset_qt,
        tcp50_free_reset_qt,
        tcp100_paid_reset_qt,
        tcp100_free_reset_qt,

        gau50_rebill_qt,
        gau100_rebill_qt,
        gau150_rebill_qt,
        gau200_rebill_qt,
        tcp25_rebill_qt,
        tcp50_rebill_qt,
        tcp100_rebill_qt,

        count_free_resets_total,
        count_reset_total,
      } = row;

      const us_net =
        gau50_net_us +
        gau100_net_us +
        gau150_net_us +
        gau200_net_us +
        tcp25_net_us +
        tcp50_net_us +
        tcp100_net_us +
        gau50_rebill_net_us +
        gau100_rebill_net_us +
        gau150_rebill_net_us +
        gau200_rebill_net_us +
        tcp25_rebill_net_us +
        tcp50_rebill_net_us +
        tcp100_rebill_net_us;

      const not_us_net =
        gau50_net_not_us +
        gau100_net_not_us +
        gau150_net_not_us +
        gau200_net_not_us +
        tcp25_net_not_us +
        tcp50_net_not_us +
        tcp100_net_not_us +
        gau50_rebill_net_not_us +
        gau100_rebill_net_not_us +
        gau150_rebill_net_not_us +
        gau200_rebill_net_not_us +
        tcp25_rebill_net_not_us +
        tcp50_rebill_net_not_us +
        tcp100_rebill_net_not_us;

      const total_net = us_net + not_us_net + resets_net_us + resets_net_not_us;
      const reportData = [
        date,
        total_net.toString(),
        (us_net + resets_net_us).toString(),
        (not_us_net + resets_net_not_us).toString(),

        tcp25_qt.toString(),
        (
          tcp25_net_not_us +
          tcp25_net_us +
          tcp25_rebill_net_not_us +
          tcp25_rebill_net_us
        ).toString(),
        tcp25_rebill_qt.toString(),
        (tcp25_reset_net_us + tcp25_reset_net_not_us).toString(),
        tcp25_paid_reset_qt.toString(),
        tcp25_free_reset_qt.toString(),

        tcp50_qt.toString(),
        (
          tcp50_net_not_us +
          tcp50_net_us +
          tcp50_rebill_net_not_us +
          tcp50_rebill_net_us
        ).toString(),

        tcp50_rebill_qt.toString(),
        (tcp50_reset_net_us + tcp50_reset_net_not_us).toString(),
        tcp50_paid_reset_qt.toString(),
        tcp50_free_reset_qt.toString(),

        tcp100_qt.toString(),
        (
          tcp100_net_not_us +
          tcp100_net_us +
          tcp100_rebill_net_not_us +
          tcp100_rebill_net_us
        ).toString(),

        tcp100_rebill_qt.toString(),
        (tcp100_reset_net_us + tcp100_reset_net_not_us).toString(),
        tcp100_paid_reset_qt.toString(),
        tcp100_free_reset_qt.toString(),

        gau50_qt.toString(),
        (
          gau50_net_not_us +
          gau50_net_us +
          gau50_rebill_net_not_us +
          gau50_rebill_net_us
        ).toString(),
        gau50_rebill_qt.toString(),
        (gau50_reset_net_us + gau50_reset_net_not_us).toString(),
        gau50_paid_reset_qt.toString(),
        gau50_free_reset_qt.toString(),

        gau100_qt.toString(),
        (
          gau100_net_not_us +
          gau100_net_us +
          gau100_rebill_net_not_us +
          gau100_rebill_net_us
        ).toString(),
        gau100_rebill_qt.toString(),
        (gau100_reset_net_us + gau100_reset_net_not_us).toString(),
        gau100_paid_reset_qt.toString(),
        gau100_free_reset_qt.toString(),

        gau150_qt.toString(),
        (
          gau150_net_not_us +
          gau150_net_us +
          gau150_rebill_net_not_us +
          gau150_rebill_net_us
        ).toString(),
        gau150_rebill_qt.toString(),
        (gau150_reset_net_us + gau150_reset_net_not_us).toString(),
        gau150_paid_reset_qt.toString(),
        gau150_free_reset_qt.toString(),

        gau200_qt.toString(),
        (
          gau200_net_not_us +
          gau200_net_us +
          gau200_rebill_net_not_us +
          gau200_rebill_net_us
        ).toString(),
        gau200_rebill_qt.toString(),
        (gau200_reset_net_us + gau200_reset_net_not_us).toString(),
        gau200_paid_reset_qt.toString(),
        gau200_free_reset_qt.toString(),

        count_reset_total.toString(),
        (resets_net_us + resets_net_not_us).toString(),
        count_free_resets_total.toString(),
      ];

      if (!this.isIgnoreWeekends) {
        this.outputRows.push(reportData);
      }

      if (this.isIgnoreWeekends && !isWeekend(new Date(date))) {
        this.outputRows.push(reportData);
      }
    });
  }

  generate(): (string | number)[][] {
    this.populateRows();
    return this.outputRows;
  }
}
